"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./lib/index'));



//////////////////
// WEBPACK FOOTER
// ./src/index.ts
// module id = 75
// module chunks = 0 1